const tokens = require("./index.ts"); // Or copy-paste the same content

module.exports = tokens;
